export default __webpack_public_path__ + "static/media/karstenDecor.7796e4f5.webp";